import type { ReactNode } from 'react';

/**
 * The loading screen a public program page shows while its client fetch runs,
 * with the server-rendered summary kept in the page BELOW it.
 *
 * WHY NOT SHOW THE SUMMARY ITSELF AS THE LOADING SCREEN. That is what these
 * pages did, and a visitor saw a plain text page flash up for a split second
 * before the real catalog replaced it.
 *
 * WHY NOT HIDE THE SUMMARY. It exists for crawlers that read the first response
 * and never run JavaScript, and the summary components forbid `sr-only`,
 * `hidden` and zero height: text only a crawler can see is cloaking. So the
 * summary stays fully visible, just pushed below a placeholder at least one
 * screen tall. A person sees the placeholder, then the real page; a crawler
 * reads the same summary it always did.
 */
export default function SummaryBelowPlaceholder({
  placeholder,
  summary,
}: {
  placeholder: ReactNode;
  summary: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-white">
      <div className="min-h-screen" data-testid="summary-placeholder">
        {placeholder}
      </div>
      {summary}
    </div>
  );
}
